// extracted by mini-css-extract-plugin
export default {"modal":"MenuModal_modal__Vlxqs","open":"MenuModal_open__igH+9","close":"MenuModal_close__Pe7xC"};